import React from 'react';
import { LinkIcon, PlusIcon, XIcon } from 'lucide-react';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface ExternalLinksSectionProps {
  pm: PM;
}
export const ExternalLinksSection: React.FC<ExternalLinksSectionProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const {
    darkMode,
    productType,
    bookForm,
    merchForm,
    eventForm,
    bookBoxForm,
    serviceForm,
    handleAddLink,
    handleAddLinkService,
    handleUpdateLink,
    handleRemoveLink,
    handleRemoveLinkService
  } = pm;
  const links = productType === 'book' ? bookForm.externalLinks : productType === 'merch' ? merchForm.externalLinks : productType === 'event' ? eventForm.externalLinks : productType === 'service' ? serviceForm.externalLinks : bookBoxForm.externalLinks;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-20455" data-mp="2ywtv3uayjfrc">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-20456" data-mp="2ptvgalbjd9rc">
        <LinkIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-20457" data-mp="2lss0fythndq4" />
        External Links
      </h2>
      <div className="space-y-3" data-id="element-20458" data-mp="2zjx2t8o8qk45">
        {links?.map((link, idx) => <div key={idx} className="flex gap-2" data-id="element-20459" data-mp="2zm16bpi89h3w">
            <input type="text" value={link.url} onChange={e => handleUpdateLink(idx, 'url', e.target.value)} className={`flex-1 p-2 text-sm rounded-md border ${dk.inputOnCard}`} placeholder="https://..." data-id="element-20460" data-mp="2ukk9c52v6esl" />
            <button onClick={() => productType === 'service' ? handleRemoveLinkService(idx) : handleRemoveLink(idx)} className="p-2 text-gray-400 hover:text-red-500" data-id="element-20461" data-mp="2gtynq8m0zqr0">
              <XIcon className="w-4 h-4" data-id="element-20462" data-mp="3n9hqu5z947ka" />
            </button>
          </div>)}
        <button onClick={productType === 'service' ? handleAddLinkService : handleAddLink} className="text-sm text-purple-600 hover:text-purple-700 font-medium flex items-center" data-id="element-20463" data-mp="3nbvis5ymx3nm">
          <PlusIcon className="w-4 h-4 mr-1" data-id="element-20464" data-mp="84zjko60kyhm" />
          Add Link
        </button>
      </div>
    </div>;
};